var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "section",
    [
      _c("FinalizarProgramacionRRHH"),
      _vm._v(" "),
      _c("RechazarProgramacionRRHH"),
      _vm._v(" "),
      _c("FinalizarProgramacionesFuncionarios"),
      _vm._v(" "),
      _c("VerDetalleSolicitudes"),
      _vm._v(" "),
      _c("VerDetalleSolicitudesProgramacion"),
      _vm._v(" "),
      _c("EnviarProgramacion"),
      _vm._v(" "),
      _c("EditarDiasReserva"),
      _vm._v(" "),
      _c(
        "h3",
        { staticClass: "primary--text" },
        [
          _c("v-icon", { attrs: { color: "primary" } }, [_vm._v("event")]),
          _vm._v(
            " Programación de vacaciones\n    " + _vm._s(_vm.periodo) + " \n  "
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-flex",
        { staticClass: "px-3" },
        [
          _c(
            "v-tooltip",
            { attrs: { bottom: "" } },
            [
              _c(
                "v-btn",
                {
                  attrs: {
                    slot: "activator",
                    color: "primary",
                    to:
                      "/vacaciones-listado-unidades/" +
                      this.$util.decodeString(this.$route.params.gestion)
                  },
                  slot: "activator"
                },
                [
                  _c("v-icon", { attrs: { dark: "" } }, [_vm._v("arrow_back")]),
                  _vm._v(" ATRAS")
                ],
                1
              ),
              _vm._v(" "),
              _c("span", [_vm._v("Atras")])
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-card",
        [
          _c("v-card-text", [
            _c("strong", [_vm._v("AÑO DE PROGRAMACIÓN : ")]),
            _vm._v(
              "\n      " +
                _vm._s(this.$util.decodeString(_vm.$route.params.gestion)) +
                "\n      "
            ),
            _c("br"),
            _vm._v(" "),
            _c("strong", [_vm._v("DEPENDENCIA : ")]),
            _vm._v(_vm._s(_vm.nombre_unidad) + "\n      ")
          ]),
          _vm._v(" "),
          _c(
            "v-card-text",
            [
              _c("v-data-table", {
                staticClass: "elevation-1 tabla-comprimida-light",
                attrs: {
                  headers: _vm.headers,
                  items: _vm.lista_funcionarios_vacaciones,
                  "no-data-text": "Sin datos",
                  "item-key": "id",
                  search: _vm.filters,
                  "custom-filter": _vm.customFilter,
                  "no-results-text": "No se encontro coincidencias",
                  "rows-per-page-items": [25, 50, { text: "Todos", value: -1 }]
                },
                scopedSlots: _vm._u([
                  {
                    key: "headerCell",
                    fn: function(props) {
                      return [
                        _c(
                          "v-tooltip",
                          {
                            attrs: { bottom: "" },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "activator",
                                  fn: function(ref) {
                                    var on = ref.on
                                    return [
                                      _c(
                                        "span",
                                        _vm._g(
                                          { staticClass: "letra-cabecera" },
                                          on
                                        ),
                                        [
                                          _vm._v(
                                            "\n                " +
                                              _vm._s(props.header.text) +
                                              "\n              "
                                          )
                                        ]
                                      )
                                    ]
                                  }
                                }
                              ],
                              null,
                              true
                            )
                          },
                          [
                            _vm._v(" "),
                            _c("span", [
                              _vm._v(
                                "\n              " +
                                  _vm._s(props.header.text) +
                                  "\n            "
                              )
                            ])
                          ]
                        )
                      ]
                    }
                  },
                  {
                    key: "items",
                    fn: function(items) {
                      return [
                        _c("td", { staticClass: "text-xs-center" }, [
                          _vm._v(_vm._s(items.item.servidor_publico))
                        ]),
                        _vm._v(" "),
                        _c("td", { staticClass: "text-xs-center" }, [
                          _vm._v(
                            "\n            " +
                              _vm._s(
                                _vm
                                  .$moment(items.item.fecha_incorporacion)
                                  .format("DD/MM/YYYY")
                              ) +
                              "\n          "
                          )
                        ]),
                        _vm._v(" "),
                        _c("td", { staticClass: "text-xs-center" }, [
                          _vm._v(_vm._s(items.item.dias_saldo_a))
                        ]),
                        _vm._v(" "),
                        _c("td", { staticClass: "text-xs-center" }, [
                          _vm._v(_vm._s(items.item.dias_saldo_b))
                        ]),
                        _vm._v(" "),
                        _c("td", { staticClass: "text-xs-center" }, [
                          _vm._v(_vm._s(items.item.dias_saldo_c))
                        ]),
                        _vm._v(" "),
                        _c("td", { staticClass: "text-xs-center" }, [
                          _vm._v(_vm._s(items.item.total_dias_saldo))
                        ]),
                        _vm._v(" "),
                        _c("td", { staticClass: "text-xs-center" }, [
                          _vm._v(_vm._s(items.item.dias_programar))
                        ]),
                        _vm._v(" "),
                        _c("td", { staticClass: "text-xs-center" }, [
                          _vm._v(_vm._s(items.item.dias_no_programados))
                        ]),
                        _vm._v(" "),
                        _c("td", { staticClass: "text-xs-center" }, [
                          _vm._v(_vm._s(items.item.ene))
                        ]),
                        _vm._v(" "),
                        _c("td", { staticClass: "text-xs-center" }, [
                          _vm._v(_vm._s(items.item.feb))
                        ]),
                        _vm._v(" "),
                        _c("td", { staticClass: "text-xs-center" }, [
                          _vm._v(_vm._s(items.item.mar))
                        ]),
                        _vm._v(" "),
                        _c("td", { staticClass: "text-xs-center" }, [
                          _vm._v(_vm._s(items.item.abr))
                        ]),
                        _vm._v(" "),
                        _c("td", { staticClass: "text-xs-center" }, [
                          _vm._v(_vm._s(items.item.may))
                        ]),
                        _vm._v(" "),
                        _c("td", { staticClass: "text-xs-center" }, [
                          _vm._v(_vm._s(items.item.jun))
                        ]),
                        _vm._v(" "),
                        _c("td", { staticClass: "text-xs-center" }, [
                          _vm._v(_vm._s(items.item.jul))
                        ]),
                        _vm._v(" "),
                        _c("td", { staticClass: "text-xs-center" }, [
                          _vm._v(_vm._s(items.item.ago))
                        ]),
                        _vm._v(" "),
                        _c("td", { staticClass: "text-xs-center" }, [
                          _vm._v(_vm._s(items.item.sep))
                        ]),
                        _vm._v(" "),
                        _c("td", { staticClass: "text-xs-center" }, [
                          _vm._v(_vm._s(items.item.oct))
                        ]),
                        _vm._v(" "),
                        _c("td", { staticClass: "text-xs-center" }, [
                          _vm._v(_vm._s(items.item.nov))
                        ]),
                        _vm._v(" "),
                        _c("td", { staticClass: "text-xs-center" }, [
                          _vm._v(_vm._s(items.item.dic))
                        ]),
                        _vm._v(" "),
                        _c("td", { staticClass: "text-xs-center" }, [
                          _vm._v(_vm._s(items.item.estado))
                        ]),
                        _vm._v(" "),
                        _c(
                          "td",
                          [
                            items.item.id_estado_vacac_progra != 22
                              ? _c(
                                  "v-btn",
                                  {
                                    attrs: {
                                      color: "#95c2f9",
                                      to:
                                        "/programacion-funcionario-RRHH/" +
                                        _vm.$util.decodeString(
                                          _vm.$route.params.gestion
                                        ) +
                                        "/" +
                                        items.item.id_persona,
                                      dark: "",
                                      icon: "",
                                      title: "Ver programaciones"
                                    }
                                  },
                                  [_c("v-icon", [_vm._v("remove_red_eye")])],
                                  1
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            items.item.id_estado_vacac_progra != 22
                              ? _c(
                                  "v-btn",
                                  {
                                    attrs: {
                                      color: "#0594A5",
                                      dark: "",
                                      icon: "",
                                      title: "Ver detalle"
                                    },
                                    on: {
                                      click: function($event) {
                                        $event.preventDefault()
                                        return _vm.verDetalleProgramacion(
                                          items.item
                                        )
                                      }
                                    }
                                  },
                                  [_c("v-icon", [_vm._v("remove_red_eye")])],
                                  1
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            items.item.id_estado_vacac_progra != 22
                              ? _c(
                                  "v-btn",
                                  {
                                    attrs: {
                                      color: "#6DE0BA",
                                      dark: "",
                                      icon: "",
                                      title: "Descripción"
                                    },
                                    on: {
                                      click: function($event) {
                                        $event.preventDefault()
                                        return _vm.verDetalle(items.item)
                                      }
                                    }
                                  },
                                  [_c("v-icon", [_vm._v("receipt")])],
                                  1
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            items.item.id_estado_vacac_progra == 51 ||
                            items.item.id_estado_vacac_progra == 73
                              ? _c(
                                  "v-btn",
                                  {
                                    attrs: {
                                      color: "#44deaa",
                                      dark: "",
                                      icon: "",
                                      title: "Aprobar programación de vacación"
                                    },
                                    on: {
                                      click: function($event) {
                                        $event.preventDefault()
                                        return _vm.aprobarProgramacionInicialRRHH(
                                          items.item
                                        )
                                      }
                                    }
                                  },
                                  [_c("v-icon", [_vm._v("done")])],
                                  1
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            items.item.id_estado_vacac_progra == 54 ||
                            items.item.id_estado_vacac_progra == 66 ||
                            items.item.id_estado_vacac_progra == 51 ||
                            items.item.id_estado_vacac_progra == 73
                              ? _c(
                                  "v-btn",
                                  {
                                    attrs: {
                                      color: "#FF5D34",
                                      dark: "",
                                      icon: "",
                                      title:
                                        "Rechazar  programación de vacación"
                                    },
                                    on: {
                                      click: function($event) {
                                        $event.preventDefault()
                                        return _vm.rechazarProgramacionRRHH(
                                          items.item
                                        )
                                      }
                                    }
                                  },
                                  [_c("v-icon", [_vm._v("close")])],
                                  1
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            items.item.id_estado_vacac_progra == 22
                              ? _c(
                                  "v-btn",
                                  {
                                    attrs: {
                                      color: "indigo",
                                      dark: "",
                                      icon: "",
                                      title: "Enviar programacion"
                                    },
                                    on: {
                                      click: function($event) {
                                        $event.preventDefault()
                                        return _vm.enviarProgramacion(
                                          items.item
                                        )
                                      }
                                    }
                                  },
                                  [_c("v-icon", [_vm._v("send")])],
                                  1
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _c(
                              "v-btn",
                              {
                                attrs: {
                                  color: "rgb(147,13,242)",
                                  dark: "",
                                  icon: "",
                                  title: "Modificar días de reserva"
                                },
                                on: {
                                  click: function($event) {
                                    $event.preventDefault()
                                    return _vm.editarDiasReserva(items.item)
                                  }
                                }
                              },
                              [_c("v-icon", [_vm._v("edit")])],
                              1
                            )
                          ],
                          1
                        )
                      ]
                    }
                  }
                ])
              })
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-fbf097f8", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-fbf097f8","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/admin/vacacion_rrhh/ListadoFuncionariosRRHHVacaciones.vue
// module id = null
// module chunks = 